import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { ReportPrintAssesmentComponent } from 'src/app/shared/report-print/report-print-assesment/report-print-assesment.component';
import { TrainingClassPrintComponent } from 'src/app/shared/report-print/training-class-print/training-class-print.component';
import { TrainingPrintComponent } from 'src/app/shared/report-print/training-print/training-print.component';
import { ViewPrintComponent } from './view-print/view-print.component';


const routes: Routes = [
  {
    path: 'print',
    pathMatch: 'prefix',
    component: ViewPrintComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    children: [
      { path: 'training-report/:studentid/:trainingid', data: { breadcrumb: 'Rapor Yazdır', roles: ['ADMIN'] }, component: TrainingPrintComponent },
      { path: 'assesment-report/:studentid/:trainingid', data: { breadcrumb: 'Rapor Yazdır', roles: ['ADMIN'] }, component: ReportPrintAssesmentComponent },
      { path: 'training-class-report/:classid/:trainingid', data: { breadcrumb: 'Rapor Yazdır', roles: ['ADMIN'] }, component: TrainingClassPrintComponent },
      { path: 'training-all-report/:trainingid', data: { breadcrumb: 'Rapor Yazdır', roles: ['ADMIN'] }, component: TrainingClassPrintComponent },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrintRoutingModule { }
